import classNames from 'classnames';
import ReactDrawer from 'rc-drawer';
import {DrawerProps, Placement} from 'rc-drawer/es/Drawer';
import {DrawerPopupProps} from 'rc-drawer/es/DrawerPopup';
import React, {CSSProperties, FC, ReactNode, useEffect, useState} from 'react';

import style from './style.module.scss';
import Icon from 'components/Icon';

interface IProps {
    autoFocus?: boolean;
    placement?: Placement;
    children: ReactNode;
    isClosable?: boolean;
    onClose?: DrawerProps['onClose'];
    isOpen: DrawerProps['open'];
    mask?: DrawerProps['mask'];
    maskClosable?: boolean;
    maskStyle?: CSSProperties;
    afterOpenChange?: DrawerPopupProps['afterOpenChange'];
    closerClassName?: string;
    closeBtnDataAutotestTarget?: string;
    closeBtnDataAutotestTargetId?: string;
}

export const motion: DrawerProps['motion'] = (placement) => {
    const nextContainer = document.getElementById('__next');
    return {
        motionAppear: true,
        motionName: `panel-motion-${placement}`,
        onEnterStart: () => {
            if (!nextContainer) {
                return;
            }

            nextContainer.style.overflow = 'hidden';
        },
        onLeaveEnd: () => {
            if (!nextContainer) {
                return;
            }
            nextContainer.style.overflow = '';
        },
    };
};

export const Drawer: FC<IProps> = ({
    placement = 'left',
    children,
    isClosable,
    isOpen,
    autoFocus,
    onClose,
    afterOpenChange,
    mask = false,
    closerClassName,
    closeBtnDataAutotestTarget,
    closeBtnDataAutotestTargetId,
    ...restProps
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const renderCloseButton = (
        <button
            className={classNames(style.drawerCloseIcon, closerClassName)}
            data-autotest-target={closeBtnDataAutotestTarget}
            data-autotest-target-id={closeBtnDataAutotestTargetId}
            onClick={onClose}
        >
            <Icon icon={'close'} />
        </button>
    );

    return (
        <ReactDrawer
            afterOpenChange={afterOpenChange}
            autoFocus={autoFocus}
            forceRender={mounted}
            mask={mask}
            motion={motion}
            onClose={onClose}
            open={mounted && isOpen}
            placement={placement}
            rootClassName={style.drawer}
            width={''}
            {...restProps}
        >
            {isClosable && renderCloseButton}
            {children}
        </ReactDrawer>
    );
};
